/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_Special_Characters
export const escapeRegexCharacters = (str: string) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Normalize text for comparison
 * Especially for value list option values, to align with API to ensure it does not break aggregation
 */
export const normalizeText = (name: string, { lowerCase = true }: { lowerCase?: boolean } = {}) => {
  const trimmedName = name.trim().replace(/\s{2,}/g, ' ');
  return lowerCase ? trimmedName.toLowerCase() : trimmedName;
};